module.exports = __webpack_public_path__ + "media/images/madori-2123824f90b1a6227615ec7c7a3c1954.png";